const sanitizeBase = (value) => {
  if (!value) {
    return '/static';
  }
  return value.endsWith('/') ? value.slice(0, -1) : value;
};

export const getStaticBase = () => {
  if (typeof window !== 'undefined' && window.__STATIC_BASE__) {
    return sanitizeBase(window.__STATIC_BASE__);
  }
  return '/static';
};

export const resolveStaticUrl = (path = '') => {
  const base = getStaticBase();
  if (!path) {
    return base;
  }
  const normalized = path.startsWith('/') ? path.slice(1) : path;
  return `${base}/${normalized}`;
};

export const replaceStaticPlaceholders = (html = '') => {
  const base = resolveStaticUrl('');
  return html.replace(/__STATIC__/g, base);
};

export const applyStaticAssetUrls = (rootNode) => {
  if (!rootNode || typeof rootNode.querySelectorAll !== 'function') {
    return;
  }
  const elements = rootNode.querySelectorAll('[data-static-src]');
  elements.forEach((element) => {
    const assetPath = element.getAttribute('data-static-src');
    if (!assetPath) {
      return;
    }
    element.setAttribute('src', resolveStaticUrl(assetPath));
  });
};
